"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pattern = void 0;
class Pattern {
    _regex;
    constructor(keys) {
        this._regex = new RegExp(keys
            .sort((a, b) => a.length - b.length)
            .map((key) => key.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\\\$&'))
            .map((key) => `\\{${key}\\}`)
            .join('|'), 'g');
    }
    format(dataGetter, pattern) {
        return pattern.replace(this._regex, (match) => {
            const key = match.slice(1, -1);
            const fn = dataGetter[key];
            if (fn) {
                const ret = fn.call(dataGetter);
                return ret;
            }
            return match;
        });
    }
}
exports.Pattern = Pattern;
//# sourceMappingURL=Pattern.js.map